var render = function render(){var _vm=this,_c=_vm._self._c;return _c('data-chip',{attrs:{"text":_vm.getReasonTitle(_vm.reason.id),"small":_vm.small}})
}
var staticRenderFns = []

export { render, staticRenderFns }